<template>
    <div class="enterprise-publicity">
        <div class="headline">
            <h1>{{$t("news.enterprisePublicity.headlineTitle")}}</h1>
            <p>{{$t("news.enterprisePublicity.headlineP")}}</p>
          </div>
          <el-row :gutter="60">
            <el-col :span="12" :xs="24" v-for="(item,index) in tabLists" :key="index">
              <div class="pic-wrap">
                <img :src="item.mainPicUrl" />
                <div class="des-box">
                  <h3>{{item.title}}</h3>
                </div>
              </div>
            </el-col>
          </el-row>
          <pagination
            v-show="total > 0"
            :total="total"
            :page.sync="pageReq.page"
            :limit.sync="pageReq.size"
            @pagination="getList"
          />
    </div>
</template>
<script>
import {getnewlist} from "../../api/news"
import { mapGetters } from "vuex";
export default {
    data(){
        return {
          total: 0,// 总条数
          pageReq: {
            page: 1,
            size: 10,
          },
          tabLists:[]
        }
    },
    computed:{
      ...mapGetters(['language'])
    },
    mounted() {
      this.getList();
      
    },
    methods:{
      getList(){
        const pageReq = {...this.pageReq};
        pageReq.page -= 1;
        getnewlist(this.language,{contentType:'3'},pageReq).then(res =>{
          const { content, totalElements } = res;
          this.tabLists = content;
          this.total = totalElements;
        })
      },
      toDetail(id) {
          this.$router.push({ path: `/news/detail/:${id}` });
      }
    }
}
</script>
<style lang="scss" scoped>
.enterprise-publicity{

  .el-col{
    margin-bottom:40px;
  }
  .pic-wrap{
    position: relative;
    overflow: hidden;
    border-radius: 20px;
    img{
      width:100%;
      height:360px;
      object-fit: cover;
    }
    .des-box{
      position: absolute;
      left:0;
      top:100%;
      width: 100%;
      height: 60px;
      line-height: 60px;
      background:rgba($color: #000000, $alpha: 0.5);
      box-sizing: border-box;
      text-align: center;
      transition: all 0.4s;
      color:#fff;
    }
    &:hover{
      .des-box{
        transform: translateY(-60px);
      }
    }
  }
}
</style>